import React from 'react';

import { useParams } from 'react-router';

import { Grid } from '@mui/material';
import { FormikHelpers, FormikProps } from 'formik';
import * as Yup from 'yup';

import { CissTextField } from 'components/fields';
import { Row } from 'components/form';
import { Block, FormPage } from 'components/page';
import { useFormContext } from 'context/FormContext';
import { useFormMutation } from 'mutations/useFormMutation';
import { initialTagValues, MarketingTag } from 'pages/marketing-trade/marketing/tag/types';

export function MarketingTagFormComp() {
    const { setContent } = useFormContext();
    const url = '/gestao/tagpecamarketing';
    const { id } = useParams();
    const { mutate } = useFormMutation();

    const handleSubmit = (values: MarketingTag, formik: FormikHelpers<MarketingTag>): void => {
        mutate(
            {
                url,
                idField: 'idTagPecaMarketing',
                formData: values,
                formik,
            },
            {
                onSuccess: (response: any) => {
                    const { data } = response.data;

                    if (data) {
                        setContent(data);
                    }
                },
            },
        );
    };

    const validationSchema = Yup.object({
        dsTagPecaMarketing: Yup.string().required(),
    });

    return (
        <FormPage title="Tags Marketing" values={initialTagValues} onSubmit={handleSubmit} url={url} validationSchema={validationSchema} goBackButton>
            {(formik: FormikProps<MarketingTag>) => {
                return (
                    <Block>
                        <Row>
                            {id && (
                                <Grid sx={{ flex: 1 }}>
                                    <CissTextField label="Código" value={id} disabled={true} name="idTagPecaMarketing" />
                                </Grid>
                            )}

                            <Grid sx={{ flex: 4 }}>
                                <CissTextField
                                    label="Tag"
                                    name="dsTagPecaMarketing"
                                    value={formik.values.dsTagPecaMarketing}
                                    error={formik.errors.dsTagPecaMarketing}
                                    onChange={(e) => formik.setFieldValue('dsTagPecaMarketing', e.target.value)}
                                />
                            </Grid>
                        </Row>
                    </Block>
                );
            }}
        </FormPage>
    );
}
